// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.RentalManagerUserInfoV2WebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserInfoV2WebApiHandler_get,
  RentalManagerUserInfoV2WebApiHandler_get_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';

interface GetParams {
  allowedSessionLengthSeconds?: number;
  extendSession?: boolean;
  includeCanClaimFreeListings?: boolean;
  includeCustomers?: boolean;
  includeProfileImageUrl?: boolean;
  pageWithSensitiveInformation?: boolean;
}

export type RentalManagerUserInfoV2WebApiHandler_get_Options = UseQueryOptions<
  RentalManagerAuthCheckUserInfoWebApiDto,
  unknown,
  RentalManagerAuthCheckUserInfoWebApiDto,
  readonly [string, GetParams]
>;

const RentalManagerUserInfoV2WebApiHandler_get_GetKey = (getParams: GetParams) =>
  [RentalManagerUserInfoV2WebApiHandler_get_Path, getParams] as const;

export const RentalManagerUserInfoV2WebApiHandler_get_queryOptions = (
  getParams: GetParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserInfoV2WebApiHandler_get_GetKey(getParams),
    queryFn: () => RentalManagerUserInfoV2WebApiHandler_get(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get data for a user; Used by all clients except mobile apps
 */
export const useRentalManagerUserInfoV2WebApiHandler_get = (
  getParams: GetParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserInfoV2WebApiHandler_get_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserInfoV2WebApiHandler_get_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserInfoV2WebApiHandler_get.getKey = RentalManagerUserInfoV2WebApiHandler_get_GetKey;
